/**
 * Совместимая с сагами пауза
 *
 * @example
 * ```
 * yield call(pause, 1000);
 * yield put(myAction());
 * ```
 *
 * @param {number} delay
 * @returns {Promise}
 */
export default function (delay: number) {
    return new Promise<void>((resolve) => {
        setTimeout(() => {
            resolve();
        }, delay);
    });
}
